import React, { useState } from 'react';
import { TextField, Button, Typography, Container, CssBaseline, Link, Grid, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import logoImage from 'imagens/logo-drogas-azul-2.png';
import TrocarSenha from './TrocarSenha';
import authService from 'services/authService'; 

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [openTrocarSenhaModal, setOpenTrocarSenhaModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await authService.login(email, password);
      const token = response.data.token;

      localStorage.setItem('token', token);

      const perfilResponse = await authService.getProfile();
      const perfil = perfilResponse.perfil;

      if (perfil === 1 || perfil === 2 || perfil === 3) {
        navigate('/admin/principal'); 
      } else {
        setError('Perfil inválido ou sem acesso.');
      }
    } catch (err) {
      console.error('Erro ao fazer login:', err);

      if (err.response && err.response.status === 401) {
        setError('Credenciais inválidas. Por favor, verifique seu email e senha.');
      } else {
        setError('Erro ao processar sua solicitação. Por favor, tente novamente mais tarde.');
      }
    }
  };

  const handleOpenTrocarSenhaModal = () => {
    setOpenTrocarSenhaModal(true);
  };

  const handleCloseTrocarSenhaModal = () => {
    setOpenTrocarSenhaModal(false);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Grid
      container
      justifyContent="center"
      sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}
    >
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div style={{ textAlign: 'center', marginTop: '8rem' }}>
          <img src={logoImage} alt="Logo" style={{ marginBottom: '2rem' }} />
          {error && <Typography variant="subtitle2" color="error">{error}</Typography>}
          <form onSubmit={handleLogin} style={{ width: '100%', marginTop: '1rem' }}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Senha"
              type={showPassword ? 'text' : 'password'}
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, backgroundColor: 'var(--azul-escuro)' }}
            >
              Entrar
            </Button>
            <Typography align="center">
              <Link href="/cadastro" variant="body2">
                Novo Cadastro
              </Link>
            </Typography>
            <Typography align="center">
              <Link href="#" onClick={handleOpenTrocarSenhaModal}>Esqueceu sua senha?</Link>
              <TrocarSenha open={openTrocarSenhaModal} handleClose={handleCloseTrocarSenhaModal} />
            </Typography>
          </form>
        </div>
      </Container>
    </Grid>
  );
};

export default Login;
